import { DataService } from './../../config/dataService/dataService';
import { Endpoints } from '../../config/Endpoints/index';
import { Encryption } from '../../utility/cryptoControl';
import Cookies from 'js-cookie';
import actions from './actions';

const {
  loginBegin,
  loginSuccess,
  loginErr,
  verifyTwoFaBegin,
  verifyTwoFaSuccess,
  verifyTwoFaErr,
  changePasswordBegin,
  changePasswordSuccess,
  changePasswordErr,
  logoutBegin,
  logoutSuccess,
  logoutErr,
} = actions;


const login = (bodyData, remember) => {
  return async dispatch => {
    bodyData.email = bodyData.email.trim();
    bodyData.password = bodyData.password.trim();

    dispatch(loginBegin());

    // try {
    const res = await DataService.post(Endpoints.Login, bodyData);

    // 2FA gerekiyorsa
    if (res?.data?.step === '2FA_REQUIRED') {
      dispatch(loginSuccess(false));
      return {
        step: '2FA_REQUIRED',
        // message: res.statusText,
        message: res?.data?.message,
      };
    }

    // normal login başarılı ise
    if (res.status === 200) {
      const data = res.data;

      // cookieleri ayarla
      if (remember) {
        Cookies.set('email', bodyData.email);
        Cookies.set('password', Encryption(bodyData.password, 'secret'));
      } else {
        Cookies.remove('email');
        Cookies.remove('password');
      }

      Cookies.set('access_token', data.token, { expires: 7 });
      Cookies.set('displayName', data.displayName);
      Cookies.set('email', data.email);
      Cookies.set('phone', data.phone || '');
      Cookies.set('logedIn', true);

      dispatch(loginSuccess(true));
      return data;
    }

    // Diğer başarısızlıklar
    const msg = res?.statusText || res?.response?.data;
    dispatch(loginErr(msg));
    
  };
};

const verifyTwoFactor = bodyData => {
  return async dispatch => {
    dispatch(verifyTwoFaBegin());

    const res = await DataService.post(Endpoints.VerifyTwoFactor, bodyData);
    if (res.status === 200) {
      const data = res.data.result;

      Cookies.set('access_token', data.token, { expires: 7 });
      Cookies.set('displayName', data.displayName);
      Cookies.set('email', data.email);
      Cookies.set('phone', data.phone || '');
      Cookies.set('logedIn', true);

      dispatch(verifyTwoFaSuccess(true));

      return data;
    }

    const msg = res?.statusText || res?.response?.data;
    dispatch(verifyTwoFaErr(msg));
  };
};

const changePassword = payload => {
  return async dispatch => {
    dispatch(changePasswordBegin());
    const response = await DataService.post(Endpoints.ChangePassword, payload);
    if (response.status === 200) {
      dispatch(changePasswordSuccess(response.data));
    } else {
      dispatch(changePasswordErr(response.statusText));
    }
    return response;
  };
};

const logOut = () => {
  return async dispatch => {
    try {
      dispatch(logoutBegin());
      await DataService.post(Endpoints.Logout);
      Cookies.remove('logedIn');
      Cookies.remove('access_token');
      dispatch(logoutSuccess(null));
    } catch (err) {
      dispatch(logoutErr(err));
    }
  };
};

export { login, verifyTwoFactor, changePassword, logOut };
